import axios from "axios";

export const state = {
  productitemunits: [],
};

export const getters = {
  productitemunits: (state) => state.productitemunits,
};

export const mutations = {
  SetProductitemunits(state, newValue) {
    state.productitemunits = newValue;
  },
};

export const actions = {
  async fetchItemUnits({ commit }) {
    await axios.get("/all_products").then((res) => {
      commit("SetProductitemunits", res.data.products);
    });
  },
};
